import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconCross from 'components/icons/IconCross';
import IconButton from 'components/common/IconButton';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  typographyLabel: {
    marginBottom: 6,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  typographyValue: {
    padding: '10px 10px 10px 10px',
    lineHeight: pxToEm(16, 16),
    borderRadius: 4,
    border: `1px dashed ${theme.palette.primary.A400}`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minHeight: 15,
  },
  buttonClear: {
    position: 'absolute',
    bottom: -5,
    right: -4,
  },
  iconCross: {
    width: 12,
    height: 12,
  },
});

const ReportsCreateEditFormStructureField = ({ label, classes, input, onClear }) => {
  return (
    <div className={classes.root}>
      <Typography className={classes.typographyLabel}>
        {label}
      </Typography>
      <Typography className={classes.typographyValue}>
        {input.value}
      </Typography>
      {(input.value && input.value.length > 0) && (
        <IconButton
          className={classes.buttonClear}
          onClick={onClear}
          tooltipContent="Clear"
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
      )}
    </div>
  );
};

ReportsCreateEditFormStructureField.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  onClear: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ReportsCreateEditFormStructureField);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditFormStructureField.js